const useIsFocused = () => {
  return true;
};

export { useIsFocused };
